import React from 'react';
import './Cart.css'

const Cart = (props) => {
    // console.log(props);

    const { cart } = props;
    console.log(cart);

    let total = 0;
    for (const billionaire of cart) {
        total = total + billionaire.net_worth
    }

    return (
        <div className='card mt-5 mx-5 card-box'>
            <h4>Billionaire's Added: <span className='text-success'>{cart.length}</span></h4>
            <h5>Total NetWorth: <span className='text-success'>${total}B</span></h5>
            <div>
                {
                    cart.map(member =>
                        <div class="card mb-3 mx-5 my-3" style={{ maxWidth:'500px'}}>
                            <div class="row g-0">
                                <div class="col-md-4">
                                    <img src={member.img} class="img-fluid rounded-start" alt="..." />
                                </div>
                                <div class="col-md-8">
                                    <div class="card-body">
                                        <h5 class="card-title align-middle">{member.name}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                <button className='btn btn-primary mb-3'><i class="fas fa-shopping-cart"></i> Hire Now</button>
            </div>
        </div>
    );
};


export default Cart;